import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/create',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function findAdminById(id){
  return request({
    url: '/admin/findAdminById/' + id,
    method: 'get',
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

//停用用户
export function deleteAdmin(id) {
  return request({
    url: '/admin/deleteById/' + id,
    method: 'post'
  })
}
//激活用户
export function activeAdmin(id) {
  return request({
    url: '/admin/activeUser/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
//获取角色列表
export function getAllRole() {
  return request({
    url: "/comment/findAllRole/",
    method: "get",
  });
}

//获取角色列表
export function getNull() {
  return request({
    url: "/admin/getNull/",
    method: "get",
  });
}

// 注册
export function register(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js